module.exports = __webpack_public_path__ + "img/empty-section.f7fcf7b7.svg";